// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__DKvnV","slideUp":"Toast_slideUp__aV8Xq","message":"Toast_message__SHRRp"};